  <footer class="page-footer" style="background-color: black !important;">
    <div class="footer-content">
      <div class="container-fluid" style="background-color: black !important;">
        <div class="row">
          <div class="col-12 col-sm-6" style="display: none !important;">
            <p class="mb-0 text-muted">ColoredStrategies 2020</p>
          </div>
          <div class="col-sm-6 d-none d-sm-block" style="display:none !important;">
            <ul class="breadcrumb pt-0 pr-0 float-right">
              <li class="breadcrumb-item mb-0">
                <a href="javascript:;" class="btn-link">Review</a>
              </li>
              <li class="breadcrumb-item mb-0">
                <a href="javascript:;" class="btn-link">Purchase</a>
              </li>
              <li class="breadcrumb-item mb-0">
                <a href="javascript:;" class="btn-link">Docs</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
